import React, { useRef, useState } from 'react';
import makeRequest from 'utils/makeRequest';

// eslint-disable-next-line no-unused-vars
import s from './AccordionWithChild.scss';

const AccordionWithChild = ({
  children,
  onToggle,
  selfOpen = true,
  scrollInView = true,
}) => {
  const [activeIndex, setActiveIndex] = useState(selfOpen ? 1 : 0);
  const itemRefs = useRef([]);

  const toggleAccordion = index => {
    // setActiveIndex(activeIndex === index + 1 ? null : index + 1);
    setActiveIndex(prevIndex => {
      const newIndex = prevIndex === index + 1 ? null : index + 1;

      // Call the parent callback if provided
      if (onToggle && typeof onToggle === 'function') {
        onToggle(index, newIndex, prevIndex);
      }

      if (scrollInView) {
        if (newIndex !== null && itemRefs.current[newIndex - 1]) {
          const element = itemRefs.current[newIndex - 1];
          setTimeout(() => {
            element.scrollIntoView({
              block: 'center',
              behavior: 'smooth',
            });
            element.focus({ preventScroll: true });
          }, 0);
        }
      }

      return newIndex; // Updateing state
    });
  };

  return (
    <div className="accordion">
      {children &&
        React.Children.map(children, (child, index) =>
          React.cloneElement(child, {
            isActive: index + 1 === activeIndex,
            toggleAccordion: () => toggleAccordion(index),
            // eslint-disable-next-line no-return-assign
            setRef: el => (itemRefs.current[index] = el),
          }),
        )}
    </div>
  );
};

const AccordionItem = ({
  isActive,
  showFeedbackAlert = false,
  toggleAccordion,
  children,
  title,
  setRef,
  msid,
  item,
}) => {
  const [showfeedback, setShowFeedback] = useState(false);
  const feedbackHandle = async (id, faqId, type) => {
    try {
      const url = `https://toiutils.indiatimes.com/search/times_iq/submit_faqs?msid=${id}&faqId=${faqId}&type=${type}&pc=toi&pfm=web`;

      const res = await makeRequest.get(url);

      if (res?.data === 'Success') {
        setShowFeedback(true);
      } else {
        setShowFeedback(true);
        console.warn('Feedback submission failed:', res?.data);
      }
    } catch (error) {
      console.error('Error submitting feedback:', error);
      setShowFeedback(true);
    }
  };
  return (
    <div className="accordion-item">
      <div
        className={`accordion-title ${isActive ? 'active' : ''}`}
        onClick={toggleAccordion}
        ref={setRef}
        tabIndex={-1}
      >
        {title} <i className="arrow" />
      </div>
      {isActive && <div className="accordion-content">{children}</div>}
      {isActive &&
        showFeedbackAlert && (
          <div className={s.feedbackContainer}>
            {!showfeedback && (
              <div className={s.feedbackQuestion}>
                <div className={s.heading}>Was this relevant?</div>
                <div className={s.likeDislike}>
                  <div
                    className={s.like}
                    onClick={() => feedbackHandle(msid, item.faqId, 'LIKE')}
                  >
                    <i className={`${s.iconLike}`} />
                  </div>
                  <div
                    className={s.dislikeOnly}
                    onClick={() => feedbackHandle(msid, item.faqId, 'DISLIKE')}
                  >
                    <i className={`${s.iconDislike}`} />
                  </div>
                </div>
              </div>
            )}

            {showfeedback && (
              <div className={s.thanksText}>
                <i />
                Thanks for your feedback!
              </div>
            )}
          </div>
        )}
    </div>
  );
};

export { AccordionWithChild, AccordionItem };
